var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 519.92 413.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ccc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 519.92,
    height: 413.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.48,28.86h-305a63.11,63.11,0,0,0-63,63V275.55a63.11,63.11,0,0,0,63,63H249.53v25.18H194.19A9.18,9.18,0,0,0,185,373v2.5a9.18,9.18,0,0,0,9.17,9.17H325.73a9.18,9.18,0,0,0,9.17-9.17V373a9.18,9.18,0,0,0-9.17-9.18H270.39V338.59H412.48a63.11,63.11,0,0,0,63-63V91.9A63.11,63.11,0,0,0,412.48,28.86ZM107.44,50h305a42,42,0,0,1,42,42v162H65.49V91.9A42,42,0,0,1,107.44,50Zm305,267.55h-305a42,42,0,0,1-41.95-41.95V275h389v.52A42,42,0,0,1,412.48,317.5Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCms);
export default __webpack_public_path__ + "static/media/cms.ea4fc002043a8e3927b6b442b202c3c9.svg";
export { ForwardRef as ReactComponent };